import { render, staticRenderFns } from "./CampaignReachExport.vue?vue&type=template&id=23d83a39&"
import script from "./CampaignReachExport.vue?vue&type=script&lang=js&"
export * from "./CampaignReachExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports